import { Currency } from '../../../components/common/Form/config';

export const LOW_CONVERTED_DECIMALS = 2;
export const MIN_CONVERTED_DECIMALS = 3;
export const MAX_CONVERTED_DECIMALS = 4;

/* eslint-disable import/prefer-default-export */
export const DECIMALS_CURRENCY: Record<
  'sell' | 'buy',
  Record<Exclude<Currency, 'USD'>, number>
> = {
  sell: {
    COP: MAX_CONVERTED_DECIMALS,
    MXN: MIN_CONVERTED_DECIMALS,
  },
  buy: {
    COP: MAX_CONVERTED_DECIMALS,
    MXN: MAX_CONVERTED_DECIMALS,
  },
};
